import type { MutableRefObject, Ref } from 'react';

/**
 * Sets the value of a ref (callback ref or ref object).
 * Used by useForkRef to forward a single ref to multiple recipients.
 */
function setRef<T>(ref: Ref<T> | undefined | null, value: T | null): void {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    (ref as MutableRefObject<T | null>).current = value;
  }
}

export default setRef;
